import React from 'react';

const CloudCoverRow = ({dayData, units, data}) => {

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 py-1 text-xs text-custom-light-grey">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        <span className="block sm:hidden">Cloud {units && units}</span>
                        <span className="hidden sm:block">Cloud Cover {units && `(${units})`}</span>
                        <span className="text-custom-light-grey/70"></span>
                    </div>
                </div>
            </td>
            {dayData.map(({ index }) => {
                const cloud_cover = data?.[index];
                return (
                    <td key={index} className="py-1 text-center">
                        <div className="inline-block">
                            {cloud_cover}
                        </div>
                    </td>
                );
            })}
        </tr>
    )
}

export default CloudCoverRow;